/**
 * When publishing or subscring to events - use the prepared event names below
 */
export const EVENT = {
  HISTORY_ACTION: "HISTORY_ACTION",
};

export type TEvent = keyof typeof EVENT;
